import React from 'react';
import { LAYOUT } from '../../styles/constants';
import useMediaQuery from '../../hooks/useMediaQuery';

interface NewsCardProps {
  index: number;
  title: string;
  description: string;
  imageUrl: string;
}

const NewsCard = ({ index, title, description, imageUrl }: NewsCardProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div 
      style={{ 
        width: isDesktop ? LAYOUT.NEWS_EVENTS.CARD.WIDTH : '100%',
        maxWidth: LAYOUT.NEWS_EVENTS.CARD.WIDTH
      }}
      className="bg-white shadow-lg overflow-hidden rounded-t-lg"
    >
      <img
        src={imageUrl}
        alt={`News ${index}`}
        style={{ height: LAYOUT.NEWS_EVENTS.CARD.IMAGE.HEIGHT }}
        className="w-full object-cover rounded-t-lg"
      />
      <div 
        className="p-6 flex flex-col justify-between"
        style={{ height: LAYOUT.NEWS_EVENTS.CARD.DESCRIPTION.HEIGHT }}
      >
        <div>
          <h3 className="text-xl font-semibold mb-3">{title}</h3>
          <p className="text-gray-600 mb-4">{description}</p>
        </div>
        <button 
          className="w-full bg-[#0A1F87] text-white py-3 rounded hover:bg-[#0A1F87]/90 transition-colors"
        >
          Read More
        </button>
      </div>
    </div>
  );
};

export default NewsCard;